/* import __COLOCATED_TEMPLATE__ from './medium-radio-button-group.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();